import { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import "@/App.css";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import Marquee from "@/components/landing/Marquee";
import Verticals from "@/components/landing/Verticals";
import CustomStudio from "@/components/landing/CustomStudio";
import NailSize from "@/components/landing/NailSize";
import Manifesto from "@/components/landing/Manifesto";
import About from "@/components/landing/About";
import Waitlist from "@/components/landing/Waitlist";
import Footer from "@/components/landing/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let frame;
    const raf = (time) => {
      lenis.raf(time);
      frame = requestAnimationFrame(raf);
    };
    frame = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(frame);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App bg-[#FAF7F2] text-[#26221F]" data-testid="app-root">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Verticals />
        <CustomStudio />
        <NailSize />
        <Manifesto />
        <About />
        <Waitlist />
      </main>
      <Footer />
      <Toaster position="bottom-center" richColors />
    </div>
  );
}

export default App;
